import type { OrderSheetDetailDto } from "@repo/types";
import apiClient from "../lib/apiClient";

export const getOrderSheetDetail = async (
  id: number
): Promise<OrderSheetDetailDto> => {
  const response = await apiClient.get<OrderSheetDetailDto>(`/order-sheet/${id}`);
  return response.data;
};




